window.CKEDITOR_BASEPATH = '/ckeditor/';
